import './EnhancedEventViewLayover.scss';
import { useTranslation } from 'react-i18next';
import { formatNumToTime } from '../../../helpers/timeHelpers';

function EnhancedEventViewLayover({pairingSegment}) {

  const getLayOverTime = () => {
    if(!pairingSegment && !pairingSegment?.hotelSegment && !pairingSegment?.hotelSegment.length && !pairingSegment?.hotelSegment[0].totalLayover){
      return 'NA';
    }

    return formatNumToTime(pairingSegment?.hotelSegment[0].totalLayover.value);
  }

  const getHotelDescription = (tooltip=false) => {
    if(!pairingSegment && !pairingSegment?.hotelSegment && !pairingSegment?.hotelSegment.length && !pairingSegment?.hotelSegment[0].hotel && !pairingSegment?.hotelSegment[0].hotel?.name){
      return 'NA';
    }
    return pairingSegment?.hotelSegment[0].hotel?.name;
  }


  const { t } = useTranslation();
  return (
    <div className='c-ev-layover'>     
      {/* render this -> only if there is layover */}
      <div className='layover-divider'></div>
      <div className='c-layover-details'>
        <div className='c-layover-time'>
          <p className='time__lbl'>{t('myBlockMonth.layover')}</p>
          <p className='time__val'>{getLayOverTime()}</p>
        </div>
        <div className='c-layover-hotel'>         
          <p className='c-hotel-info'> 
            <span className='icon-Hotel hotel__icon'></span>
            <span className='hotel__lbl'>{t('myBlockMonth.hotel')}</span>
          </p>
          <p className='c-hotel-detail' title={getHotelDescription()}>
            <span>{getHotelDescription()}</span>
          </p>
          <p className='hotel__phone'>{pairingSegment?.hotelSegment[0].hotel?.phone}</p>
        </div>
      </div>
    </div>

  );
}

export default EnhancedEventViewLayover;
